import { placeTypeOptions, type PlaceType } from "../data/destinations";

type Props = { selected: PlaceType[]; counts: Partial<Record<PlaceType, number>>; onChange: (selected: PlaceType[]) => void };

export function PlaceTypeFilter({ selected, counts, onChange }: Props) {
  const toggle = (value: PlaceType) => onChange(selected.includes(value) ? selected.filter((item) => item !== value) : [...selected, value]);
  return <div className="field-group type-filter">
    <div className="type-filter-head"><span className="app-select-label">Tipo di posto</span>{!!selected.length && <button type="button" className="text-button" onClick={() => onChange([])}>Mostra tutti</button>}</div>
    <div className="type-chips" role="group" aria-label="Filtra per tipo di posto">
      {placeTypeOptions.map((option) => {
        const active = selected.includes(option.value);
        const count = counts[option.value] ?? 0;
        return <button type="button" key={option.value} className={`type-chip ${active ? "is-active" : ""}`} aria-pressed={active} onClick={() => toggle(option.value)} disabled={!count && !active}>{option.label}<small>{count}</small></button>;
      })}
    </div>
  </div>;
}
